import { Pipe, PipeTransform } from '@angular/core';

/**
 * `FillPipe` is a pipe that takes a value n and returns an iterator that yields n items in ascending order
 * @example
 * // returns `[1, 2, 3]` iterator
 * fillPipe.transform(3);
 */
@Pipe({ name: 'fill', standalone: false })
export class FillPipe implements PipeTransform {
  transform(value: number) {
    const iterable = <Iterable<number>>{};
    iterable[Symbol.iterator] = function* () {
      let n = 0;
      while (n < value) {
        yield ++n;
      }
    };
    return iterable;
  }
}
